import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

import AccordianCommon from "../../../components/Shared/AccordianCommon";

class Faqs extends Component {
  render() {
    const ids = ["tech", "general", "payment", "support"];
    return (
      <React.Fragment>

        <section className="section">
          <Container>
            <Row className="justify-content-center">

              <Col lg={8} md={7} xs={12}>
                <div className="section-title" id="tech">
                  <h4>Вопросы-ответы:</h4>
                </div>
                <div className="faq-content mt-4 pt-2">
                  <div className="accordion" id="accordionExampleone">
                    {/* accoridan */}
                    <AccordianCommon
                      question1="Через сколько будет готов сайт?"
                      answer1="При наличии списка товаров, сайт будет готов к заказу через 20 минут."
                      question2="Какие платежные системы можно подключить?"
                      answer2="Практически любые. Альфа-Банк, Сбер, Тинькоф, ЮКасса, Robokassa, Cloudpayments и другие. Онлайн-экваринг Вашего банка или любая платежная система имеющая API."
                      question3="Могу ли я переходить с тарифа на тариф?"
                      answer3="Да! Многие компании начинают с минимального тарифа, а после, когда понимают, что на сайте необходима онлайн-оплата, переходят на тариф Бизнес. При увеличении оборота компании, смена тарифа произойдет автоматически. Подробнее об условиях перехода с тарифа на тариф можете прочитать в договоре оферты."
                      question4="Почему так дешево?"
                      answer4="Наша цель: помочь как можно большему количеству компаний. Все нуждаются в улучшении клиентского сервиса и увеличении онлайн-продаж. Мы знаем, как этого добиться. Но также понимаем, что не все компании на рынке могут позволить себе приобрести наше программное обеспечение целиком. Поэтому мы предлагаем взять его «по подписке» и только с теми функциями, которые необходимы компании."
                      question5="Правила размещения на серверах. Передача проектов."
                      answer5="Проект разрабатывается на тестовой среде (тестовый домен + сервер). После проверки клиентом проект переносится на индивидуальный сервер в нашей инфраструктуре и Вы делегируете на него домен по А записи.Проект создается и управляется нашей платформой, которая размещается и обслуживается только на наших серверах. Мы не передаем доступы к исходному коду проекта, серверам. Вы получаете полноценный доступ к административной части управления проектом."
                    />
                  </div>
                </div>

              </Col>
            </Row>
          </Container>

        </section>
      </React.Fragment>
    );
  }
}

export default Faqs;
